import React, { useEffect, useMemo, useState } from "react";
import Icon from "@mdi/react";
import {
  mdiMagnify,
  mdiCogOutline,
  mdiLogout,
  mdiLockReset,
  mdiCartOutline,
  mdiClipboardTextOutline,
  mdiHistory,
  mdiPackageVariantClosed,
  mdiTagOutline,
  mdiBellOutline,
  mdiCheckAll,
} from "@mdi/js";
import axios from "axios";
import Cookies from "universal-cookie";
import Pagination from "react-js-pagination";

import { getBranch, getDomain, getUserLogin } from "utils/utils";
import { pushNotification } from "utils/notifications";

import GioHang from "./GioHang";
import "./DatHangDaiLy.css";
import DonDatHang from "./DonDatHang";
import GiaoDich from "./GiaoDich";
import BaoGiaDaiLy from "./BaoGiaDaiLy";
import DatHangDaiLyApi from "../../service/datHangDaiLyApi";
import FullScreenLoading from "./loading/FullScreenLoading";

const initSearch = {
  tensanpham: "",
  nhomsanphamId: -1,
  hashtag: 0,
  pageIndex: 1,
  pageSize: 8,
};

const initList = {
  iTotal: 0,
  List: [],
};

const DEFAULT_PRODUCT_IMAGE =
  "data:image/svg+xml;charset=UTF-8,%3Csvg width='220' height='220' viewBox='0 0 220 220' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='220' height='220' rx='12' fill='%23f1f5f9'/%3E%3Cpath d='M62 155h96V75H62v80zm10-70h76v60H72V85z' fill='%23cbd5e1'/%3E%3Ccircle cx='92' cy='105' r='10' fill='%23e2e8f0'/%3E%3Cpath d='M75 140l28-28 18 18 12-12 17 22H75z' fill='%23e2e8f0'/%3E%3Ctext x='110' y='180' text-anchor='middle' font-size='14' font-family='Arial' fill='%2394a3b8'%3ENo image%3C/text%3E%3C/svg%3E";

export default function DatHangDaiLy() {
  const params = new URLSearchParams(window.location.search);

  const defaultTab = params.get("tab") || "products";

  const [tab, setTab] = useState(defaultTab);

  useEffect(() => {
    if (params.get("tab")) {
      const url = new URL(window.location.href);

      url.searchParams.delete("tab");

      window.history.replaceState({}, "", url.pathname + url.search);
    }
  }, []);
  const [showSetting, setShowSetting] = useState(false);
  const [showThongBao, setShowThongBao] = useState(false);
  const [thongBaoList, setThongBaoList] = useState([]);
  const [soChuaDoc, setSoChuaDoc] = useState(0);

  const loadThongBao = () => {
    DatHangDaiLyApi.getThongBao(getUserLogin().UserName)
      .then((res) => {
        if (res.status === 200 && res.data) {
          setThongBaoList(res.data.List || []);
          setSoChuaDoc(res.data.SoChuaDoc || 0);
        }
      })
      .catch(() => {});
  };

  const handleClickThongBao = (item) => {
    if (!item.Noti_TrangThai) {
      DatHangDaiLyApi.danhDauDaDoc(getUserLogin().UserName, item.ID)
        .then(() => loadThongBao())
        .catch(() => {});
    }
    if (item.Link) window.location.href = item.Link;
  };

  const handleDocTatCa = () => {
    DatHangDaiLyApi.danhDauTatCaDaDoc(getUserLogin().UserName)
      .then(() => loadThongBao())
      .catch(() => {});
  };

  const [dataSearch, setDataSearch] = useState(initSearch);
  const [listSanPham, setListSanPham] = useState(initList);
  const [listNhomSanPham, setListNhomSanPham] = useState([]);
  const [listHashtag, setListHashtag] = useState([]);
  const [isStartProcess, setIsStartProcess] = useState(false);

  const [cartItems, setCartItems] = useState([]);

  const [branchList, setBranchList] = useState([]);
  const [branchId, setBranchId] = useState(getBranch());

  const loadGioHang = () => {
    DatHangDaiLyApi.listThongTinGioHang(getUserLogin().UserName)
      .then((response) => {
        if (response.status === 200) {
          if (response.data) {
            setCartItems(JSON.parse(response.data || "[]"));
          }
        }
      })
      .catch((err) => {
        console.log("Lỗi load giỏ hàng", err);
      });
  };
  useEffect(() => {
    loadBranch();
    loadData(initSearch);
    loadNhomSanPham();
    loadHashtag();
    loadGioHang();
    loadThongBao();
    const timer = setInterval(loadThongBao, 60000);
    const handleClickOutside = (e) => {
      if (!e.target.closest(".dealer-noti-wrap")) setShowThongBao(false);
      if (!e.target.closest(".dealer-setting")) setShowSetting(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      clearInterval(timer);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const loadBranch = () => {
    const cookies = new Cookies();
    const userToken = cookies.get("userTokenDaiLy");

    if (!userToken) {
      window.location.href = "/DangNhap";
      return;
    }

    axios
      .get(
        `${getDomain()}chinhanh/listChiNhanh?sUserName=${getUserLogin().UserName}`,
        {
          headers: {
            Authorization: userToken.substring(6),
          },
        },
      )
      .then((res) => {
        const list = res.data?.List || [];

        setBranchList(list);

        const currentCookieBranch = cookies.get("ChiNhanh");

        if (!currentCookieBranch && list.length > 0) {
          cookies.set("ChiNhanh", list[0].BranchID, { path: "/" });
          setBranchId(list[0].BranchID);
        }
      })
      .catch((err) => {
        console.log("Lỗi lấy danh sách chi nhánh", err);
      });
  };

  const loadNhomSanPham = () => {
    DatHangDaiLyApi.listNhomSanPham(getBranch())
      .then((response) => {
        if (response.status === 200) {
          setListNhomSanPham(response.data?.List || []);
        }
      })
      .catch((err) => {
        console.log("Lỗi lấy nhóm sản phẩm", err);
      });
  };

  const loadHashtag = () => {
    DatHangDaiLyApi.listHashtag()
      .then((response) => {
        if (response.status === 200) {
          setListHashtag(response.data?.List || []);
        }
      })
      .catch((err) => {
        console.log("Lỗi lấy hashtag", err);
      });
  };

  const loadData = (search = dataSearch) => {
    setIsStartProcess(true);

    DatHangDaiLyApi.list({
      username: getUserLogin().UserName,
      tensanpham: search.tensanpham || "",
      nhomsanphamId: search.nhomsanphamId || -1,
      hashtag: search.hashtag || 0,
      branchId: getBranch(),
      pageIndex: search.pageIndex,
      pageSize: search.pageSize,
    })
      .then((response) => {
        console.log(response, "responseresponseresponseresponse");
        setIsStartProcess(false);

        if (response.status === 200) {
          setListSanPham({
            List: response.data?.List || [],
            iTotal: response.data?.TotalRow || 0,
          });
        } else {
          pushNotification(response.data, "error", "TOP_RIGHT", 2000);
        }
      })
      .catch((err) => {
        setIsStartProcess(false);
        console.log("Lỗi lấy danh sách sản phẩm", err);
        pushNotification(
          "Lỗi lấy danh sách sản phẩm",
          "error",
          "TOP_RIGHT",
          2000,
        );
      });
  };

  const onChangeBranch = (e) => {
    const value = e.target.value;
    const cookies = new Cookies();

    cookies.set("ChiNhanh", value, { path: "/" });
    setBranchId(value);

    window.location.reload(false);
  };

  const updateTextValue = (field) => (e) => {
    const value = e.target.value;

    setDataSearch((prev) => ({
      ...prev,
      [field]: value,
      pageIndex: 1,
    }));
  };

  const getCartKey = (item) => `${item.CategoryID}_${item.OptionID || 0}`;

  const cartTotalQty = useMemo(() => {
    return cartItems.length;
  }, [cartItems]);
  const cartTotalQty1 = useMemo(() => {
    return cartItems.reduce(
      (total, item) => total + Number(item.SoLuongMua || 0),
      0,
    );
  }, [cartItems]);

  const onSearch = () => {
    const search = {
      ...dataSearch,
      pageIndex: 1,
    };

    setDataSearch(search);
    loadData(search);

    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  const handlePageChange = (pageNumber) => {
    const search = {
      ...dataSearch,
      pageIndex: pageNumber,
    };

    setDataSearch(search);
    loadData(search);

    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  const formatProduct = (item) => ({
    ...item,
    OptionID: Number(item.OptionID || 0),
    IsMuaGiaCong: item.IsMuaGiaCong || false,
    SoLuongMua: Number(item.SoLuongMua || 1),
    CategoryPrice: Number(item.CategoryPrice || 0),
    ListOption: item.ListOption || [],
  });

  const saveCartToApi = (listCart) => {
    const params = {
      UserName: getUserLogin().UserName,
      GioHangNoiDung: JSON.stringify(listCart),
    };

    DatHangDaiLyApi.addGioHang(params)
      .then((res) => {
        console.log(res, "aaaaaaaaaaaa");
        console.log("Lưu giỏ hàng thành công");
      })
      .catch((err) => {
        console.log("Lỗi lưu giỏ hàng", err);
      });
  };

  const addToCart = (product) => {
    const cartKey = getCartKey(product);

    setCartItems((prev) => {
      const existed = prev.find((x) => getCartKey(x) === cartKey);

      let newCart = [];

      if (existed) {
        newCart = prev.map((x) =>
          getCartKey(x) === cartKey
            ? {
                ...x,
                SoLuongMua:
                  Number(x.SoLuongMua || 0) + Number(product.SoLuongMua || 1),
              }
            : x,
        );
      } else {
        newCart = [product, ...prev];
      }

      saveCartToApi(newCart);

      return newCart;
    });
  };

  const updateCartItems = (newCartItems) => {
    setCartItems(newCartItems);
  };

  return (
    <div className="dealer-page">
      {isStartProcess && <FullScreenLoading />}

      {branchList.length > 1 && (
        <div className="dealer-branch-header">
          <div className="dealer-container dealer-branch-header-inner">
            <select
              className="dealer-branch-select"
              value={branchId}
              onChange={onChangeBranch}
            >
              {branchList.map((branch) => (
                <option key={branch.BranchID} value={branch.BranchID}>
                  {branch.BranchName}
                </option>
              ))}
            </select>
          </div>
        </div>
      )}

      <div className="dealer-container">
        {tab === "products" && (
          <>
            <div className="dealer-topbar">
              <div className="dealer-search-box">
                <input
                  type="text"
                  placeholder="Tìm kiếm theo tên sản phẩm"
                  value={dataSearch.tensanpham}
                  onChange={updateTextValue("tensanpham")}
                  onKeyDown={(e) => e.key === "Enter" && onSearch()}
                />

                <button onClick={onSearch}>
                  <Icon path={mdiMagnify} size={0.9} />
                </button>
              </div>

              <select
                className="dealer-filter-select"
                value={dataSearch.nhomsanphamId}
                onChange={(e) => {
                  const value = e.target.value;

                  const search = {
                    ...dataSearch,
                    nhomsanphamId: value,
                    pageIndex: 1,
                  };

                  setDataSearch(search);
                  loadData(search);
                }}
              >
                <option value="-1">Chọn nhóm hàng</option>
                {listNhomSanPham.map((item) => (
                  <option
                    key={item.GroupCategoryID}
                    value={item.GroupCategoryID}
                  >
                    {item.GroupName}
                  </option>
                ))}
              </select>

              {/* <select
              className="dealer-filter-select"
              value={dataSearch.hashtag}
              onChange={(e) => {
                const value = e.target.value;

                const search = {
                  ...dataSearch,
                  hashtag: value,
                  pageIndex: 1,
                };

                setDataSearch(search);
                loadData(search);
              }}
            >
              <option value="0">Hashtag</option>
              {listHashtag.map((item) => (
                <option key={item.Value} value={item.Value}>
                  {item.Text}
                </option>
              ))}
            </select> */}

              {/* Bell thông báo */}
              <div className="dealer-noti-wrap">
                <button
                  className="dealer-noti-btn"
                  onClick={() => { setShowThongBao(!showThongBao); setShowSetting(false); }}
                >
                  <Icon path={mdiBellOutline} size={1} />
                  {soChuaDoc > 0 && (
                    <span className="dealer-noti-badge">{soChuaDoc > 99 ? "99+" : soChuaDoc}</span>
                  )}
                </button>
                {showThongBao && (
                  <div className="dealer-noti-dropdown">
                    <div className="dealer-noti-header">
                      <span>Thông báo</span>
                      {soChuaDoc > 0 && (
                        <button className="dealer-noti-readall" onClick={handleDocTatCa}>
                          <Icon path={mdiCheckAll} size={0.8} />
                          Đọc tất cả
                        </button>
                      )}
                    </div>
                    <div className="dealer-noti-list">
                      {thongBaoList.length === 0 ? (
                        <div className="dealer-noti-empty">Không có thông báo</div>
                      ) : (
                        thongBaoList.map((item) => (
                          <div
                            key={item.ID}
                            className={`dealer-noti-item${item.Noti_TrangThai ? "" : " unread"}`}
                            onClick={() => handleClickThongBao(item)}
                          >
                            <div className="dealer-noti-title">
                              {!item.Noti_TrangThai && <span className="dealer-noti-new">NEW</span>}
                              {item.Noti_TieuDe}
                            </div>
                            <div className="dealer-noti-content">{item.Noti_NoiDung}</div>
                            <div className="dealer-noti-time">
                              {item.Noti_NgayGui
                                ? new Date(item.Noti_NgayGui).toLocaleString("vi-VN", { hour: "2-digit", minute: "2-digit", day: "2-digit", month: "2-digit", year: "numeric" })
                                : ""}
                            </div>
                          </div>
                        ))
                      )}
                    </div>
                  </div>
                )}
              </div>

              <div className="dealer-setting">
                <button
                  className="setting-btn"
                  onClick={() => { setShowSetting(!showSetting); setShowThongBao(false); }}
                >
                  <Icon path={mdiCogOutline} size={1} />
                </button>

                {showSetting && (
                  <div className="setting-menu">
                    <button
                      onClick={() => {
                        window.location.href = "/Users/DoiMatKhau";
                      }}
                    >
                      <Icon path={mdiLockReset} size={0.85} />
                      Đổi mật khẩu
                    </button>

                    <button
                      onClick={() => {
                        const cookies = new Cookies();

                        cookies.remove("userTokenDaiLy", { path: "/" });
                        cookies.remove("ChiNhanh", { path: "/" });

                        window.location.href = "/DangNhap";
                      }}
                    >
                      <Icon path={mdiLogout} size={0.85} />
                      Đăng xuất
                    </button>
                  </div>
                )}
              </div>
            </div>

            <div className="dealer-hashtag-tabs">
              <button
                className={Number(dataSearch.hashtag) === 0 ? "active" : ""}
                onClick={() => {
                  const search = {
                    ...dataSearch,
                    hashtag: 0,
                    pageIndex: 1,
                  };

                  setDataSearch(search);
                  loadData(search);
                }}
              >
                Tất cả
              </button>

              {listHashtag.map((item) => (
                <button
                  key={item.Value}
                  className={
                    Number(dataSearch.hashtag) === Number(item.Value)
                      ? "active"
                      : ""
                  }
                  onClick={() => {
                    const search = {
                      ...dataSearch,
                      hashtag: item.Value,
                      pageIndex: 1,
                    };

                    setDataSearch(search);
                    loadData(search);
                  }}
                >
                  {item.Text}
                </button>
              ))}
            </div>
          </>
        )}

        <div
          className={
            tab === "products" ? "dealer-content" : "dealer-content no-search"
          }
        >
          {tab === "products" && (
            <>
              <div className="product-grid">
                {listSanPham.List && listSanPham.List.length > 0 ? (
                  listSanPham.List.map((item, index) => {
                    const product = formatProduct(item);

                    return (
                      <ProductCard
                        key={product.CategoryID || index}
                        item={product}
                        onAddToCart={addToCart}
                      />
                    );
                  })
                ) : (
                  <div className="product-empty">
                    {isStartProcess
                      ? "Đang tải dữ liệu..."
                      : "Không có dữ liệu"}
                  </div>
                )}
              </div>

              {listSanPham.iTotal > 0 && (
                <div className="paggination-ver2 text-center pagination-Main justify-content-center">
                  <div className="total-page">
                    Tổng số {listSanPham.iTotal} bản ghi
                  </div>
                  <Pagination
                    activePage={dataSearch.pageIndex}
                    itemsCountPerPage={dataSearch.pageSize}
                    totalItemsCount={listSanPham.iTotal}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    hideNavigation={true}
                    itemClass="cssPage-item"
                    linkClass="cssPageLink"
                    activeClass="cssActiveClass"
                  />
                </div>
              )}
            </>
          )}

          {tab === "cart" && (
            <GioHang
              cartItems={cartItems}
              setCartItems={updateCartItems}
              onOrderSuccess={() => setTab("orders")}
            />
          )}

          {tab === "orders" && <DonDatHang />}

          {tab === "history" && <GiaoDich />}

          {tab === "baogiadaily" && <BaoGiaDaiLy />}
        </div>
      </div>

      <div className="dealer-bottom-nav">
        <button
          className={tab === "products" ? "active" : ""}
          onClick={() => { setTab("products"); loadThongBao(); }}
        >
          <Icon path={mdiPackageVariantClosed} size={1.1} />
          <span>Danh sách hàng hóa</span>
        </button>

        <button
          className={tab === "cart" ? "active" : ""}
          onClick={() => setTab("cart")}
        >
          <Icon path={mdiCartOutline} size={1.1} />
          <span>Giỏ hàng {cartTotalQty > 0 ? `(${cartTotalQty})` : ""}</span>
        </button>
        <button
          className={tab === "baogiadaily" ? "active" : ""}
          onClick={() => setTab("baogiadaily")}
        >
          <Icon path={mdiTagOutline} size={1.1} />
          <span>Báo giá</span>
        </button>
        <button
          className={tab === "orders" ? "active" : ""}
          onClick={() => setTab("orders")}
        >
          <Icon path={mdiClipboardTextOutline} size={1.1} />
          <span>Đơn đặt hàng</span>
        </button>
        <button
          className={tab === "history" ? "active" : ""}
          onClick={() => setTab("history")}
        >
          <Icon path={mdiHistory} size={1.1} />
          <span>Giao dịch</span>
        </button>
      </div>
    </div>
  );
}

function ProductCard({ item, onAddToCart }) {
  const [qty, setQty] = useState(Number(item.SoLuongMua || 1));
  const [selectedOptionId, setSelectedOptionId] = useState(
    Number(item.OptionID || 0),
  );

  const listOption = item.ListOption || [];

  const selectedOption = listOption.find(
    (x) => Number(x.TypeOfUnitForSale) === Number(selectedOptionId),
  );

  const currentPrice = selectedOption
    ? Number(selectedOption.OptionPrice || 0)
    : Number(item.CategoryPrice || 0);

  const unitName = item.TenDonViXuat || "";

  const changeQty = (value) => {
    const onlyNumber = value.toString().replace(/[^0-9.]/g, "");
    setQty(onlyNumber);
  };

  const decreaseQty = () => {
    const currentQty = Number(qty || 0);
    setQty(currentQty > 1 ? currentQty - 1 : 1);
  };

  const increaseQty = () => {
    const currentQty = Number(qty || 0);
    setQty(currentQty + 1);
  };

  const handleAddToCart = () => {
    const qtyValue = Number(qty || 0);

    if (qtyValue <= 0) {
      pushNotification(
        "Bạn vui lòng nhập số lượng mua",
        "error",
        "TOP_RIGHT",
        2000,
      );
      return;
    }

    const productAdd = {
      ...item,
      OptionID: selectedOption
        ? Number(selectedOption.TypeOfUnitForSale || 0)
        : 0,
      OptionName: selectedOption ? selectedOption.Name : "",
      IsMuaGiaCong: !!selectedOption,
      SoLuongMua: qtyValue,
      CategoryPrice: currentPrice,
      TenDonViXuat: item.TenDonViXuat,
      SelectedOption: selectedOption || null,
    };

    onAddToCart(productAdd);
    pushNotification(
      "Thêm vào giỏ hàng thành công",
      "success",
      "TOP_RIGHT",
      2000,
    );
  };
  const handleChangeOption = (e) => {
    const value = Number(e.target.value || 0);

    setSelectedOptionId(value);

    item.OptionID = value;
    item.IsMuaGiaCong = value !== 0;
  };

  return (
    <div className="product-card">
      <div className="product-image-wrap">
        <img
          src={item.CategoryImage || DEFAULT_PRODUCT_IMAGE}
          alt={item.CategoryName}
          onError={(e) => {
            e.currentTarget.src = DEFAULT_PRODUCT_IMAGE;
          }}
        />
      </div>

      <div className="product-name">{item.CategoryName}</div>

      {/* <div className="product-price">
        {Number(currentPrice || 0) === 0
          ? "Liên hệ"
          : `${Number(currentPrice).toLocaleString()} đ`}
      </div> */}
      <div className="product-price-row">
        <span>
          Giá:
          <b>
            {Number(currentPrice || 0) === 0
              ? " Liên hệ"
              : ` ${Number(currentPrice).toLocaleString()} đ`}
          </b>
        </span>

        <span>BG: {/* <b>{item.BG || 0}</b> */}</span>
      </div>

      <div className="product-unit">Quy cách: {unitName}</div>

      {listOption.length > 0 && (
        <div className="product-option-wrap">
          <select
            className="product-option-select"
            value={selectedOptionId}
            onChange={handleChangeOption}
          >
            <option value="0">Chọn kiểu gia công</option>
            {listOption.map((opt, index) => (
              <option key={index} value={opt.TypeOfUnitForSale}>
                {opt.Name}
              </option>
            ))}
          </select>
        </div>
      )}

      <div className="product-unit-cart-row">
        <div className="product-qty-row">
          <button type="button" onClick={decreaseQty}>
            -
          </button>

          <input
            value={qty}
            onChange={(e) => changeQty(e.target.value)}
            onBlur={() => {
              if (Number(qty || 0) <= 0) {
                setQty(1);
              }
            }}
          />

          <button type="button" onClick={increaseQty}>
            +
          </button>
        </div>

        <button
          type="button"
          className="add-cart-icon-btn"
          onClick={handleAddToCart}
          title="Thêm vào giỏ hàng"
        >
          <Icon path={mdiCartOutline} size={0.95} />
        </button>
      </div>
    </div>
  );
}
